module.exports = __webpack_public_path__ + "static/img/walkway-turn_256.8b012a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walkway-turn_256.png
// module id = nyIy
// module chunks = 0